import '../../../src/global.css'
import React from 'react'
import { Box, Button, Typography } from '@material-ui/core'

/* shown to a logged in user that has no roles yet (new user created by thairath auth) */
export default function NoPermission() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <Typography variant="h6">
        บัญชีของคุณยังไม่ได้เปิดใช้งาน กรุณาติดต่อผู้ดูแลระบบเพื่อขอสิทธิ์การใช้งาน
      </Typography>
      <Box mt={2}>
        <Button variant="contained" color="primary" href="/logout">
          ออกจากระบบ
        </Button>
      </Box>
    </Box>
  )
}
